import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import authenticationMiddleware from './common/middleware/authMiddleware';
import requestMiddleware from './common/middleware/requestMiddleware';
import navigationMiddleware from './common/middleware/navigation/navigationMiddleware';
import { timerMiddleware } from './common/middleware/timerMiddleware';

const logger = store => {
    return next => {
        return action => {
            const result = next(action);

            if (process.env.NODE_ENV !== 'production') {
                console.log('[Middleware] Dispatching', action); //eslint-disable-line
                console.log('[Middleware] next state', store.getState()); //eslint-disable-line
            }

            /* 
                SAF-12524: Logins to test WalkMe on Safety
                Storing keycloak id in variable and exposing it globally(through window object).
                so that walk me use it uniquely identify users.
                Patch Release: 6.5.2
                Author: Sourabh
            */   
            let uuid = store.getState().user.sub;
            window.uuid = uuid;

            return result;
        };
    };
};

const composeSetup =
    process.env.NODE_ENV !== 'production' &&
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        : compose;

// const testAuth = {
//   initialize: () => Promise.resolve(),
//   refreshToken: (onSuccess, onFail) => Promise.resolve().then(onSuccess),
//   redirectToLogin: () => {},
//   logout: () => {},
//   getToken: () => 5
// }

// const testHttp = response => ({ sendRequest: () => Promise.resolve(response) });

const createReduxStore = (rootReducer, auth, http, history) =>
    createStore(
        rootReducer,
        composeSetup(
            applyMiddleware(
                authenticationMiddleware(auth, history),
                requestMiddleware(auth, http),
                navigationMiddleware(history),
                timerMiddleware,
                logger,
                thunk
            )
        )
    );

export default createReduxStore;
